import React from 'react';
import Carousel from 'react-bootstrap/Carousel'
import Spinner from 'react-bootstrap/Spinner';
import PropTypes from 'prop-types';

class JACarousel extends React.Component {
    constructor(props) {
        super(props);
        this.setIndex = this.setIndex.bind(this)

        this.state = {
            index: 0,
        };
    }
    setIndex(selectedIndex){
        this.setState({index: selectedIndex,});
    }
    render(){
        if (!this.props.images.length){
            return(
                <Spinner animation="border" role="status">
                    <span className="sr-only">Processing...</span>
                </Spinner>
            );
        }
        const handleSelect = (selectedIndex) => {
            this.setIndex(selectedIndex);
        };
        return(
            <Carousel controls={true} activeIndex={this.state.index} onSelect={handleSelect}>
                {
                    this.props.images.map((image, ia) => {
                        return(
                            <Carousel.Item key={'image_' + ia}>
                                <img
                                    className=""
                                    src={"assets/images/" + image.file}
                                    alt={image.alt}
                                />
                                <Carousel.Caption>
                                    <h5>{image.caption}</h5>
                                </Carousel.Caption>
                            </Carousel.Item>)
                    })
                }
            </Carousel>
        );
    }
}
JACarousel.propTypes = {
    images: PropTypes.array,
};

export default JACarousel;